var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14924 0.410115C4.50303 0.408077 5.55444 0.316888 5.9998 1.76431C6.2998 2.73931 6.77769 4.33641 7.43345 6.5556H7.70052C8.40377 4.21597 8.88686 2.61888 9.1498 1.76431C9.5998 0.301811 10.7248 0.410144 11.1748 0.410144L14.6467 0.410148V10.8101H11.1081V4.68124H10.8708L8.89816 10.8101H6.23581L4.26321 4.6767H4.02592V10.8101H0.487305V0.410148L4.14924 0.410115ZM19.728 0.410148V6.54359H20.0103L22.4098 1.5001C22.8756 0.496436 23.8683 0.410148 23.8683 0.410148H27.2926V10.8101H23.6801V4.6767H23.3978L21.0454 9.72019C20.5796 10.7193 19.5398 10.8101 19.5398 10.8101H16.1155V0.410148H19.728ZM39.7791 5.3523C39.2752 6.72736 37.6927 7.71215 35.9407 7.71215H32.1523V10.8101H28.717V5.3523H39.7791Z",
    fill: "#0F754E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1067 0.410156H28.5371C28.7173 2.72555 30.7879 4.70767 32.9315 4.70767H40.0181C40.427 2.78331 39.0192 0.410156 36.1067 0.410156Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.0876,
    y1: 3.11348,
    x2: 28.5371,
    y2: 3.11348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.5cb10104.svg";
export { ForwardRef as ReactComponent };